import request from "./index";

export const ClientChatCase = {
  List: (data) => {
    return request.post(`/api/ClientChatCase/List/`, data);
  },
  Create: (data) => {
    return request.post(`/api/ClientChatCase`, data);
  },
  GetById: (id) => {
    return request.get(`/api/ClientChatCase/GetClientChatCaseById/${id}`);
  },
  Update: (id, data) => {
    return request.put(`/api/ClientChatCase/${id}`, data);
  },
};